<template>
  <div>
    <div v-if="showmodal">
      <!-- template for the modal component -->
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container modal-width900">
              <div>
                <!-- <slot name="header"></slot> -->
                <button
                  type="button"
                  data-dismiss="modal"
                  @click="$emit('cancelAction')"
                  class="close d-close"
                >
                  <i class="material-icons">close</i>
                </button>
              </div>

              <div class="container">
                  <div class=" terms-title">
                    <h3>Terms of Service</h3>
                  </div>
                  <div class=" terms-content-sec">
                    <p class="mb-3">
                      Before proceeding to use the site please read and
                      familiarize yourself with the website terms of service.
                      Using the site and/or any of the services, signing up for
                      an account, digitally accepting the terms of use or using
                      the services offered by Genamet means that you are
                      consenting to these terms of use and the privacy policy of
                      Genamet and are bound by them. Please do not use the site
                      if you do not accept the terms of service.
                    </p>

                    <p class="mb-3">
                      We will post any revisions here with an effective date and
                      in case we make significant changes to these terms of
                      service, we may notify you by sending an email or any
                      other means as deemed appropriate
                    </p>

                    <p class="mb-3">
                      Genamet is a healthcare platform developed, managed, and
                      owned by <strong>Wisdomleaf Technologies Private Limited</strong>, a
                      company incorporated in India. Genamet offers Practice and
                      Clinic Management Software on a SaaS (software as a
                      service) model. Software is licensed to Tenants. No title
                      or intellectual property rights of the software is
                      transferred.
                    </p>

                    <p class="mb-3">
                      These terms of use are a legally binding agreement between
                      you (Tenant, Tenant’s users, users of Genamet and its
                      services, member, subscriber) and Wisdomleaf Technologies
                      Private Limited, Bangalore India (absolute owner of
                      Genamet and its services). Genamet and its services are
                      available to individuals aged 18 years and above and legal
                      entities
                    </p>

                    <h2>1. Website Owner</h2>
                    <p class="mb-3">
                      Genamet and the services offered by Genamet are operated
                      by Wisdomleaf Technologies (P) Ltd, registered in India
                      under company number U72200KA2003PTC032027 with registered
                      office at 71/1 Margosa Road, Malleswaram, Bangalore 560
                      055. You can contact us solutions@genamet.com.
                    </p>

                    <h2>2. Tenant and User</h2>
                    <p class="mb-3">
                      These Terms of Use apply to the Tenant, Tenant Admin,
                      Tenant Users, Tenant Staff and all other users created and
                      managed by the Tenant. “Tenant” can mean an individual or
                      business entity. It includes Tenant Account admin/owner,
                      owner of the Practice, employees, agents, vendors,
                      consultants, suppliers, providers, doctors, staff,
                      contractors, or other service providers who are granted
                      access to the Tenant’s account with the authorization of
                      the Tenant Account admin/owner. The Tenant is responsible
                      for the obligations and activities under the Account as
                      well as the obligations and activities of all Users and
                      Team Members within the Account. The terms of use also
                      apply to all non-tenant users such as clients/patients of
                      Tenants and all users who access www.genamet.com and its
                      services.
                    </p>
                    <p class="mb-3">
                      Access or licenses would be provided to the number of
                      users (providers and staff) in line with subscription
                      chosen. The Tenant admin is considered as a provider
                      license. Each user can be accessed by one individual.
                      Passwords should not be shared with anyone else, and the
                      Tenant is entirely responsible for ensuring that use of
                      Genamet and services offered by Genamet is in compliance
                      with all existing laws and regulations. Genamet grants the
                      Tenant with a revocable license to access and use the
                      Service specifically as set in the terms of use. Tenant
                      consents to pay the subscription fee and all such fee that
                      is applicable to the use of Genamet’ s services. The fee
                      depends on the plan chosen and not on the usage.
                      Subscription fee and all other fees are collected through
                      a PCI compliant payment gateway. Genamet is not
                      responsible for any loss or damage due to the use of such
                      payment gateway.
                    </p>
                    <p class="mb-3">
                      “User(s)” means the Tenant, Tenant Admin, Providers,
                      Staff, Team Member, Tenant’s clients or patients, Tenant
                      Admin, Providers, Staff, Consultants and other users
                      created by the Tenant. User also includes non-Tenants who
                      use Genamet and the services provided by Genamet.
                    </p>

                    <h2>3. Setting up an account</h2>
                    <p class="mb-3">
                      Tenant will have to set-up an account to start using
                      Genamet or its services. Tenant shall provide complete,
                      accurate and the most updated information to Genamet while
                      setting up the account and thereafter while using the
                      settings page and all in all other places where
                      information is required. Tenant (and Tenant’s users) are
                      responsible for the security of their usernames and
                      passwords. Tenant undertakes to notify Genamet immediately
                      in the event of any unauthorised access to the Tenant’s
                      account, username, or password.
                    </p>

                    <h2>4. Mini website Service for Tenants</h2>
                    <p class="mb-3">
                      Genamet allows Tenant admins the ability to create and
                      publish a mini website for their practice. The domain name
                      of the mini website will be:
                    </p>
                    <p>www.</p>
                    <p class="mb-3">
                      If the Tenant admin has a domain of their choice, they can
                      connect that existing domain to the mini website created
                      using Genamet.
                    </p>

                    <h3>4.1 Content</h3>
                    <p class="mb-3">
                      The Tenant confirms ownership and authorship of all
                      content uploaded on the mini website. All such content
                      should not be blasphemous, inflammatory, fraudulent,
                      scurrilous, damaging, derogatory, disparaging, ethnically
                      unacceptable, promote animosity, abusive, exhibit
                      pornographic content, or be against any country/ethnic
                      group and cause incitement. The ownership of all such
                      content submitted and published on the Tenant’s
                      mini-website vests with the Tenant. The Tenant is
                      responsible for the accuracy and completeness of such
                      content. The Tenant mini website may offer the option of
                      online appointment bookings. Genamet takes no
                      responsibility for the accuracy of the available slots,
                      fees, online payment and other details. Genamet also takes
                      no responsibility for any misconduct by the Tenant or
                      inappropriate treatment provided by the Tenant.
                      Cancellation and refund policies are independently
                      determined by each Tenant. The Tenant agrees to keep
                      Genamet indemnified against any claim that may arise from
                      the breach of an individual, business owner or business
                      entity’s intellectual property rights.
                    </p>

                    <h3>4.2 Intellectual Property Rights</h3>
                    <p class="mb-3">
                      The Tenant must ensure that the content so published does
                      not infringe on the intellectual property rights of any
                      third party, be it an individual, business owner or a
                      business entity. All content submitted & subsequently
                      published on the Tenant’s mini website (including that of
                      all providers and staff under the Tenant license) would
                      automatically mean that the Tenant has granted a
                      royalty-free world-wide license to Genamet to modify,
                      replicate, reproduce, analyse and publish the Tenant’s
                      content for the purpose of displaying, distributing and
                      promoting the mini-website. A third party cannot copy the
                      contents of the Tenant mini website.
                    </p>

                    <h3>4.3 Termination of Tenant Account</h3>
                    <p class="mb-3">
                      The mini website remains operational till the Tenant
                      account remains current. Termination of the Tenant account
                      would automatically close the mini website of the Tenant.
                    </p>

                    <h3>4.4 Authenticity of content</h3>
                    <p class="mb-3">
                      Genamet is not responsible in any manner for the accuracy,
                      authenticity, or completeness of any information or
                      personal information/data uploaded by the Tenant in the
                      respective mini website such as, but not limited to
                      services offered, academic qualifications, highlights,
                      service fees, timings, and locations among others. All
                      visitors and users of Genamet should make efforts on their
                      own to verify the information provided by the Tenant
                    </p>

                    <h3>4.5 Site traffic</h3>
                    <p class="mb-3">
                      Traffic in the Tenant website is assigned to Genamet who
                      can utilise any third-party service(s) to monitor, measure
                      and analyse traffic.
                    </p>

                    <h3>4.6 Warranties</h3>
                    <p class="mb-3">
                      Wisdomleaf Technologies Private Limited provides access to
                      Genamet and its services without warranty of any kind
                      (express or implied) and on an ‘As Is” basis. Genamet does
                      not provide or make any representation, warranty, or
                      guarantee, be it express or implied, about the accuracy
                      and completeness of any such content, data or information.
                      The Tenant must delete any content that is not compliant
                      legally. Genamet reserves the right to delete/modify any
                      content that is deemed unacceptable and if such acts are
                      repeated, terminate the Tenant or suspend the Tenant’s
                      mini website at the sole discretion of Genamet. The
                      content should not contain any links to any other website
                      or service that competes with Genamet.Tenant is
                      exclusively responsible for all acts or omissions in
                      connection with the use of Genamet and its services
                      including incomplete, inaccurate or missing information.
                      The Tenant and all users of Genamet and its services agree
                      that the contents in the site or the Tenant mini websites
                      are not to be taken as professional medical or healthcare
                      advice. The Tenant and the users should not rely on the
                      content without independent corroboration and confirmation
                      by independent medical practitioners. Wisdomleaf
                      Technologies assumes no liability or responsibility for
                      any medical advice, prescription, doctor summary and
                      recommendations among others delivered through Genamet or
                      its services. Genamet provides no warranties that its
                      services meet the compliance standards required locally.
                    </p>

                    <h3>4.7 Attribution</h3>
                    <p class="mb-3">
                      Genamet may, at its own discretion display attribution
                      text or links such as Powered by Genamet in the Tenant
                      website, prescription, invoice, receipt, emails, SMS and
                      other places as necessary. These attributions cannot be
                      deleted, altered, modified or defaced. Genamet has the
                      right to list a Tenant as a client in <a href="www.genamet.com.">www.genamet.com.</a>
                      Tenant agrees to waive moral and privacy rights, and
                      rights of attribution. We may use such listing and modify
                      it as necessary and promote and distribute in
                      advertisements, publicity material and other works at
                      Genamet’ s sole discretion.
                    </p>

                    <h2>
                      5. Indemnity for Infringement of intellectual property
                      rights of third parties
                    </h2>
                    <p class="mb-3">
                      The Tenant agrees to indemnify Genamet and holds
                      Wisdomleaf Technologies Private Limited, its Directors,
                      Employees, Consultants, Agents, Affiliates,
                      Representatives and Suppliers harmless from all third
                      party claims or loss (including direct, indirect or
                      reputational) incurred as a result of any infringement of
                      the intellectual property rights of any person or business
                      entity by the Tenant or any unauthorised person or third
                      party using the Tenant’s account with or without the
                      knowledge of the Tenant. The Tenant agrees to provide
                      adequate assistance at the Tenant’s expense to defend any
                      such claim, cost, or liability. Tenant should ensure that
                      no private content is publicly available through the mini
                      website or the Tenant provider portal. Genamet takes no
                      responsibility for any content provided by the Tenant.
                      Content available in public will be indexed by search
                      engines
                    </p>

                    <h2>6. Restrictions on use</h2>
                    <h3>6.1 Ownership of Intellectual Property</h3>
                    <p class="mb-3">
                      Tenant or any user will not copy, sell, reproduce,
                      display, distribute, or republish any content that
                      violates the intellectual property including patent,
                      copyright, trademark, trade secret, privacy or proprietary
                      rights of Genamet or any third party or report any content
                      in anyway other than as listed or intended to be listed.
                      Wisdomleaf Technologies Private Limited is the owner/
                      licenser of all intellectual property rights in the site
                      and the material published in it including all rights,
                      title and patents, inventions, copyrights, trademarks,
                      trade secrets and all other intellectual property relating
                      to the website and the services provided by the Website
                      including product names, marks, logos, symbols, domain
                      names, tag lines used in the website.
                    </p>

                    <h3>6.2 License to Tenant</h3>
                    <p class="mb-3">
                      Genamet allows the Tenant to upload, download, store
                      content as text, videos, information, audios, images etc.
                      The Tenant is the owner of the content created and stored
                      by the Tenant. The Tenant confirms that such data belongs
                      to the Tenant and has been received in a legal manner. No
                      data may be unlawfully received or stored, and the Tenant
                      is absolutely responsible for the consequences arising out
                      of such illegal activities. Tenant cannot license,
                      sublicense, sell, resell, transfer, assign, distribute or
                      otherwise commercially exploit or make available Genamet
                      (website account or mobile app account or Genamet
                      services) to any third party.
                    </p>

                    <h3>6.3 Ownership of client/patient data</h3>
                    <p class="mb-3">
                      The Tenant is the absolute owner of all data pertaining to
                      the patients/clients of the Tenant. The Tenant grants
                      Genamet permission to access, copy, distribute, share,
                      transmit, and publicly display the content of the Tenant’s
                      account as required for the purpose of providing the
                      service to the Tenant. When using Genamet or the services
                      provided by Genamet, a small fee may be applicable if the
                      Tenant would like us to provide a copy of the Tenant’s
                      data. In certain cases, analysis of the Tenant owned data
                      might be published as reports or the Tenant owned data
                      provided to third parties in an anonymised manner. No
                      personal identifiers would be made available.
                    </p>

                    <h3>6.4 Disclosure of Tenant personal details</h3>
                    <p class="mb-3">
                      As part of a re-organisation or a sale, Wisdomleaf
                      Technologies may disclose the Tenant’s personal details
                      (but not that of the Tenant’s clients/patients) to another
                      third party. The third party, in the event of a sale,
                      enjoys the same rights as that of Wisdomleaf Technologies
                      Private Limited.
                    </p>

                    <h3>6.5 Tenant and user responsibilities</h3>
                    <p class="mb-3">
                      <span class="p-1">6.5.1</span> Tenant will ensure that
                      credentials assigned to a user is not shared with another
                      member within the Tenant’s practice. Tenant will put in
                      place adequate precautions to prevent unauthorised access
                      to Genamet and its services and prevent hacking and
                      defacing of the website. The Tenant also undertakes to
                      ensure that multiple people do not access the same user
                      account. The Tenant is responsible for maintaining the
                      confidentiality of the password and other user credentials
                      that the Tenant creates while accessing the services
                      provided by Genamet. Damages incurred due to passwords
                      being disclosed will remain the responsibility of the
                      Tenant.
                    </p>

                    <p class="mb-3">
                      <span class="p-1">6.5.2</span> Tenant will not use Genamet
                      and its services for any unlawful, abusive, threatening
                      and libellous activities.
                    </p>

                    <p class="mb-3">
                       <span class="p-1">6.5.3</span> Tenant will not post jobs in the Tenant mini website
                      or elsewhere in Genamet.
                    </p>

                    <p>
                     <span class="p-1">6.5.4</span>The Tenant will not transmit spyware or any software
                      with virus, worm, time bomb, trojan horse or any malicious
                      program.
                    </p>

                    <p>
                     <span class="p-1">6.5.5</span> No user may impersonate or misrepresent or attempt
                      to gain unauthorised access to the account of any Tenant
                      of Genamet or cause others from using Genamet or its
                      services.
                    </p>

                    <p>
                     <span class="p-1">6.5.6</span> No user can launch web crawlers or web spiders or
                      cause undue burden on Genamet servers using programs to
                      hinder the normal working of Genamet and its services.
                      Tenant cannot reverse engineer, decompile, disassemble or
                      modify the services provided by Genamet.
                    </p>

                    <p>
                     <span class="p-1">6.5.7</span> Tenant takes responsibility for the acts of the
                      Tenant’s users, clients, and patients. The Tenant account
                      may be terminated for violation of the terms of use,
                      fraud, misuse, falsification, or violation of law.
                    </p>

                    <p>
                      <span class="p-1">6.5.8</span> Genamet communicates with the Tenant using the phone
                      number and email provided by the Tenant. Tenant should
                      keep their details always updated. Tenant and Tenant’s
                      users and all other users agree to receive communication
                      over email or any other means of electronic communication
                      such as WhatsApp and Skype, among others. All
                      communication to Genamet may be sent as an email to
                      solutions@genamet.com
                    </p>

                    <p>
                      <span class="p-1">6.5.9</span> Any password, OTP (one time password), users name or
                      any other piece of information that is provided to you as
                      part of our security procedures is confidential and
                      specific to you. Such information should not be shared
                      with anyone else.
                    </p>

                    <p>
                      <span class="p-1">6.5.10</span> Tenant and users of the Tenant’s Teleconsulting
                      feature are responsible for appropriate conduct while
                      using the Teleconsulting feature offered by Genamet. The
                      Teleconsulting feature should not be used for illegal or
                      unauthorised or criminal activities.
                    </p>

                    <h2>7. Patient Portal</h2>
                    <p>
                      Tenant practice created health records are available to
                      the patient/client in the patient portal after due
                      authentication. Genamet does not validate the information
                      provided by Tenant. To correct discrepancies, please
                      contact the respective practitioners.
                    </p>

                    <h2>8. Billing and Subscription plans</h2>
                    
                      <p>
                        <span class="p-1">a)</span>
                        All charges associated with your subscription plan are
                        payable in advance for the month unless it is a free
                        trial plan.
                      </p>
                      <p>
                        <span class="p-1">b)</span>
                        You authorize us or our authorized agents to bill your
                        credit card upon your subscription to the service.
                      </p>
                      <p>
                        <span class="p-1">c)</span>
                        We may use a third-party service provider to manage
                        credit card and other payment processing. Such a service
                        provider is not permitted to store, retain or use your
                        personal information except to process your credit card
                        payment.
                      <p>
                      <p>
                        <span class="p-1">d)</span>
                        No refunds shall be applicable for the non-use of a
                        service once you have signed up for a paid subscription.
                        All subscription charges are non-refundable unless
                        specified otherwise.
                      </p>
                      <p>
                        <span class="p-1"> e)</span>
                        A grace period of two calendar days would be given if
                        the payment towards subscription charges is not paid on
                        the due day. After that we will suspend your access to
                        the use of the services until we receive your payment
                        towards subscription charges. The amount will be
                        restored only on payment of a restoration fee of $25.
                      </p>
                      <p>
                        <span class="p-1"> f)</span>
                        Requests for your data stored in Genamet’s servers would
                        attract an additional one-time fee of $100.
                      </p>
                     <p>
                      <span class="p-1">g)</span>
                        Upgrades and downgrades are possible. Downgrading may
                        cause loss of features and reduce the number of users
                        who can access Genamet’ s services. Downgrading will
                        become effective from the date of the next payment due
                        and no pro-rata refunds would be provided for non-use of
                        any feature till the payment due date. In the case of an
                        upgrade, the account will be automatically upgraded the
                        same day and the amount charged accordingly.
                      </p>
                      <p>
                        <span class="p-1">h)</span>
                        Subscription charges do not include taxes, government
                        levies, VAT, GST, with-holding taxes. Taxes as
                        applicable would be charged. We will invoice you for
                        applicable taxes and you agree to pay such taxes if
                        invoiced.
                      </p>
                    <h2>9. Support</h2>
                    <p>
                      Genamet aims to excel in providing support to Tenants and
                      their users. Tenants may raise a support request ticket by
                      sending a mail to <a href="mailto:solutions@genamet.com.">solutions@genamet.com.</a> All such support
                      emails are sought to be responded within two business,
                      days. Genamet support staff may contact the Tenant or the
                      user by email, phone, Skype, chat, WhatsApp or any other
                      means depending on Genamet’ s prevailing support policies.
                      Support is available on weekdays between 10 am IST and 7
                      PM IST and between 10 am IST to 2 PM IST on weekends.
                    </p>
                    <p>
                      To resolve a support ticket, Genamet may require well
                      documented examples of the alleged issue at hand. This
                      will help in replication of the alleged error under
                      practical conditions. Any defect caused due to
                      inappropriate use or unauthorised use or due to defects in
                      the Tenant’s network or computer or caused by an external
                      software over which Genamet has no control will not be
                      addressed.
                    </p>

                    <h2>10. Assigning the agreement</h2>
                    <p>
                      In the event of a sale, transfer, merger, acquisition,
                      sale of assets or a reorganisation, this agreement can be
                      assigned partially or fully at the sole discretion of
                      Genamet. The Tenant cannot assign, sub license, or
                      transfer this agreement or account without our written
                      consent.
                    </p>

                    <h2>11. Dispute Resolution</h2>
                    <p>
                      Genamet aims to prevent any dispute with Tenants. Users
                      may send an email to solutions@genamet.com with complete
                      details of their account and the issue that needs
                      resolution. We strive to resolve all issues within a
                      reasonable period and in an amicable manner. If any action
                      or proceeding is brought in connection with the agreement,
                      the venue of such action shall be the courts in the city
                      of Bangalore, State of Karnataka, India.
                    </p>

                    <h2>12. Restrictions</h2>
                    <p>
                      From time to time we may restrict access to all or some
                      parts of the site and services to registered users. We
                      also reserve the right to restrict access to the
                      site/service offered by the site if in our opinion, you
                      use the site in contravention of the terms of service.
                    </p>

                    <h2>13. Availability of Genamet and its services</h2>
                    <p>
                      In rare instances Genamet and its services may not be
                      available due to circumstances that are beyond our control
                      such as acts of God, acts of Government, acts of terror,
                      labour problems or technology breakdown. Genamet does not
                      claim that the services provided by Genamet (and its
                      services) are continuous, virus free and error free.
                      Access may not be available during planned or emergency
                      maintenance or during upgrades. All planned maintenance
                      will be scheduled at a non-peak time for the majority of
                      our clients. No compensation or damages or refund is
                      payable for direct, indirect and consequential loss to a
                      Tenant or user for any kind of service interruption.
                      Irrespective of whether the Tenant account is terminated
                      because of non-payment of subscription fee or by Genamet,
                      or by you, or by Genamet, no refund of previously paid
                      amounts is possible. The Tenant continues to be liable for
                      any previously unpaid amounts owed to Genamet.
                    </p>

                    <h2>14. Termination</h2>
                    <p>
                      Genamet grants the Tenant a non-exclusive and
                      non-transferable limited right to access and use the
                      services for internal business purposes only. Access to
                      the services may be terminated at any time without any
                      notice. Access and use of these services cease at the end
                      of the trial period unless the Tenant completes the
                      subscription order. Information that is entered by the
                      Tenant during the trial period will be permanently lost
                      unless a subscription order is completed.
                    </p>
                    <p>
                      Genamet at its sole discretion may suspend or in some
                      cases terminate a Tenant account if the agreement on terms
                      of use is breached or if Genamet and/or its services are
                      wrongfully used (such as wrongful use of Genamet,
                      inappropriate content, criminal purposes, wrong facts,
                      violation of confidentiality, privacy, security or
                      integrity). If a subscription remains unpaid, the account
                      will be blocked after a period of 3 days from the due
                      date. Two more attempts to obtain payment will be made in
                      the next 7 days, after which the account will be
                      permanently terminated. The Tenant account may also be
                      terminated if the Tenant does not accept any changes to
                      the Terms of use. Access to all data (including files)
                      would be no longer available if the account is terminated.
                      In the case of cancellation of subscription or account
                      termination, all content and data will be deleted within
                      180 days from the date of account termination. Genamet is
                      not responsible for any loss of data due to account
                      suspension or termination. In the case of account
                      termination due to non-payment of subscription, the Tenant
                      may request for the Clinic data of the Tenant’s practice
                      which will be made available within 90 days of the request
                      as a CSV file. Such requests have to be made within 180
                      days of account termination by sending a mail to<a href="mailto:solutions@genamet.com.">
                      solutions@genamet.com </a> by providing all details of the
                      account. If the account is terminated for any reason other
                      than non-payment of subscription, Genamet is not obligated
                      to provide the Tenant data. Obligations under indemnity
                      and intellectual property rights remain valid post
                      termination as well. On termination, all licenses,
                      software and the service will automatically terminate.
                      Reinstatement of a Terminated account will attract a fee
                      of US$50.
                    </p>

                    <h2>15. Severability</h2>
                    <p>
                      Any provision in the terms of use that Is deemed invalid,
                      void or illegal shall not invalidate other provisions of
                      the agreement. All other provisions remain valid and in
                      force.
                    </p>

                    <h2>16. Other conditions</h2>
                      <p>
                        <span class="p-1">a)</span>
                        Genamet is not responsible for any third-party sites
                        that are linked from Genamet or Tenant’s mini websites.
                      </p>
                      <p>
                        <span class="p-1">b)</span>
                        Genamet has the right to modify the services offered
                        from time to time for any reason, at its sole
                        discretion.
                     </p>
                      <p>
                        <span class="p-1">c)</span>
                        Genamet will not use, retain, disclose, share or sell
                        any Personal Information except for performing the
                        obligations under these Terms of Service except if
                        required by law or by a court order.
                      </p>
                      <p>
                        <span class="p-1">d)</span>
                        Tenant is responsible for obtaining consent from
                        patients/clients for collecting and storing their
                        personal information in Genamet and its services.
                      </p>
                      <p>
                        <span class="p-1">e)</span>
                        There are no third-party beneficiaries created by this
                        agreement. A Tenant does not become an employee, agent,
                        partner or franchise of Genamet or Wisdomleaf
                        Technologies Private Limited.
                      </p>
                      <p>
                        <span class="p-1">f)</span>
                        Genamet may engage with third party providers for
                        integrating their services and making the integrated
                        service available to the Tenant. Genamet takes no
                        responsibility for any acts of omission by such third
                        parties. The Tenant shall keep Genamet indemnified for
                        any loss, damages, claims, expenses suffered due to such
                        acts by the third parties.
                      </p>
                      <p>
                        <span class="p-1">g)</span>
                        Genamet may add new services and charge for these
                        services separately.
                      </p>
                       <p>
                        <span class="p-1">h)</span>
                        Tenant will ensure payments on time and ensure that your
                        credit or debit cards or other payment instruments
                        continue to be valid.
                      </p>
                       <p>
                        <span class="p-1">i)</span>
                        Tenant cannot sell, assign, sublicense, rent, lease or
                        transfer the license provided by Genamet. You cannot
                        translate, disassemble, decompile, reverse assemble,
                        reverse engineer all or any part of the Service.
                      </p>
                       <p>
                        <span class="p-1">j)</span>
                        Genamet is not responsible for delay in delivery of
                        email and SMS.
                      </p>
                       <p>
                        <span class="p-1">k)</span>
                        Genamet reserves the right to modify or terminate any
                        provision of the terms of use and at any time and at its
                        sole discretion.
                      </p>
                       <p>
                        <span class="p-1">l)</span>
                        Genamet may update or change the terms of use or this
                        agreement from time to time. You are deemed to have
                        accepted any revisions or changes if Tenant or user
                        accesses Genamet or its services after the terms are
                        updated/changed.
                      </p>
                      <p>
                        <span class="p-1">m)</span>
                        Genamet will permit access to the Tenant’s health
                        information and data to its system developers (including
                        employees, suppliers, contractors) with appropriate
                        confidentiality agreements in place.
                      </p>
                       <p>
                        <span class="p-1">n)</span>
                        Genamet reserves the right to revise the subscription
                        rates by giving 30 days prior notice through a notice in
                        the website or through an email.
                      </p>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>


<script>
export default {
  props: ["actionmessage", "showmodal"],
  data() {
    return {};
  },
  methods: {
    closemsg() {},
  },
  create() {},
  // computed: {
  //   getModal() {},
  // },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: block;
  transition: opacity 0.3s ease;
  overflow-y: auto;
}

.modal-wrapper {
  display: inline-block;
  vertical-align: middle;
  margin-top:40px;
  margin-bottom:40px;
}

.modal-container {
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}
.terms-title {
  text-align: center;
  margin-top:20px;
  margin-bottom:20px;
  font-weight:600;
  font-size:22px;
}
.terms-content-sec {
  text-align: left;
  padding-left:25px;
  padding-right:25px;
}

.terms-content-sec h2 {
  font-size: 20px;
}

.terms-content-sec h3 {
  font-size: 16px;
}

.terms-content-sec a{
  color:blue;
}
.terms-content-sec h2,
.terms-content-sec h3 {
  font-weight: 400;
}
.p-1 {
  font-weight: 500;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-container.modal-width900 {
  max-width: 900px;
  padding: 20px;
}
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}


</style>